module.exports = __webpack_public_path__ + "img/img_work_step_2_bg.105bd78d.jpg";